import type { Prototype } from "../prototype-types";

export const yikaiZhouPrototypes: Prototype[] = [
  {
    id: "yz-spe-ai-assisted-flow-mock",
    name: "SPE AI-assisted flow (mock)",
    path: "/yz/spe-ai-assisted-flow-mock",
    description:
      "Empty Catalog Connect–style SPE backdrop → AI wizard (reorderable image grid like SPE) → snapshot populates the shell after a mock draft.",
    owner: "Yikai Zhou",
    createdAt: "2026-05-14",
    lastUpdated: "2026-05-14",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/3b167c91d75514e04876b4d7da31fedeca953d24ccf7c2fd5269dd2479468bec.png",
    creationTool: "cursor",
  },
  {
    id: "yz-spe-ai-inline-spe-mock",
    name: "SPE AI inline (mock)",
    path: "/yz/spe-ai-inline-spe-mock",
    description:
      "Full SPE (no wizard): images first, then mock AI title, description, and product options with wizard-matching sparkle tooltips.",
    owner: "Yikai Zhou",
    createdAt: "2026-05-19",
    lastUpdated: "2026-05-19",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/133d43af9c4818c4e95a2f18f3e0edc66604eb5cef6b271a5b6ad9b72465a11a.png",
    creationTool: "cursor",
  },
  {
    id: "yz-commission-invoice",
    name: "Commission invoice",
    path: "/yz/commission-invoice",
    description:
      "Slate mock of brand-portal commission invoice (production: HTML from taxable-brand-invoices API).",
    owner: "Yikai Zhou",
    createdAt: "2026-05-21",
    lastUpdated: "2026-05-21",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/9eba72b1d62bb85766b1f05fe19b1e0ad43ebd5b5012503ab403431eee0cd594.png",
    creationTool: "cursor",
  },
  {
    id: "yz-order-payout-summary",
    name: "Order payout summary",
    path: "/yz/order-payout-summary",
    description:
      "Payment details payout calculations on brand order page, including Tax on Ship with Faire.",
    owner: "Yikai Zhou",
    createdAt: "2026-05-25",
    lastUpdated: "2026-05-25",
    surfaceArea: "Brand",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/7bcfa4f7c4d4d709fd7930db6cff04ce3e5f4a4a0334c0dcfc4a146b85284539.png",
    creationTool: "cursor",
  },
  {
    id: "yz-fin-490-bc-retailer-profile",
    name: "FIN 490 BC Retailer Profile",
    path: "/yz/fin-490-bc-retailer-profile",
    description:
      "BC retailer settings profile page showcasing FIN 490 collection: a Resale credentials card flips between Not on file and On file, and Review and sign opens the Certificate of Exemption modal — business details, a mailing address picked from the addresses on file, certification checkbox, and a typed signature previewed in Nantes italic.",
    owner: "Yikai Zhou",
    createdAt: "2026-08-25",
    lastUpdated: "2026-09-03",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/yz-fin-490-bc-retailer-profile.png",
    creationTool: ["cursor", "claude-code"],
  }
];
